<template>
  <TextInput
    :value="formattedValue"
    type="date"
    @input="handleInput"
  />
</template>

<script setup>
import { computed } from 'vue';

import TextInput from '../input/TextInput.vue';

const props = defineProps({
  value: {
    type: [String, Number],
    required: true,
  },
});

const emit = defineEmits(['input']);

const formattedValue = computed(() => {
  return props.value ? props.value.slice(0, 10) : '';
});

function handleInput(dateStr) {
  const isoDate = new Date(dateStr).toISOString();
  emit('input', isoDate);
}
</script>
